export default "__VITE_ASSET__BA6j5Qs4__"